import axios from 'axios';
import React, { useState } from 'react';
import { render } from 'react-dom';
import './Story.css';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import NumericInput from 'react-numeric-input';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FaBriefcase, FaGraduationCap, FaTrophy, FaStar, FaAward, FaCode } from "react-icons/fa";
import Timeline from 'react-elegant-timeline';
import "react-elegant-timeline/dist/styles.css";
import { HiArrowNarrowRight } from "react-icons/hi";

function Story({ children }) {
  const [menuSelection, setMenuSelection] = useState('');
  const [openIndex, setOpenIndex] = useState(0);
  const [rezMethod, setRezMethod] = useState(null);
  const [numberValue, setNumberValue] = useState(2);
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [selectedTimeValue, setSelectedTimeValue] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("No Preference"); // default
  const [open, setOpen] = React.useState(false);
  const [guestsOpen, setGuestsOpen] = useState([]);

  return (
    <span className="home-page" id="main-home-div">
      <div className="our-story-div">
      <img className="front_jpg" src="front_restaurant.jpg" alt="entry"/>
      <div className="row-our-story">
        <div className="col-md-12">
        {/* <img className="front_jpg" src="front_restaurant.jpg" alt="entry"/> */}
          <b><h4>Our Story</h4></b><br/>
          <i><p className="early-years-p"><b>Location</b></p></i><p>The Heritage House is located just seven miles from Lake Geneva, at the crossroads of major
          cities like Chicago, Milwaukee, Madison, and Rockford. Because of its prime location, it has
          welcomed both locals and travelers for decades.</p><br/>
          
          <div className="underline-under-top-paragraph">__________________________________</div>
          <br/><br/>
          <i><p className="early-years-p"><b>The Early Years</b></p></i>
          <p className="early-years-p">Although extensively expanded and remodeled in 1974, the building now known as Heritage
House was not entirely new; it had earlier origins. According to local lore, one of the original
owners was Johnny Meyers, a professional wrestler. The main structure likely dates to the
1920s, as evidenced by county records and the long history of the “Hi-Way Grill” at this location.
According to the Greater Harvard Area Historical Society, owners Al &amp; Wanda Froehlke (Wanda
ran the kitchen while Al managed the front of house), came to Harvard in the mid-1950s from an
inn in Elkhorn, WI, and even brought along a large white horse statue from their old
establishment; by 1956, this statue “stood sentry” in front of the restaurant.</p><br/>
        {/* </div>
      </div>
      <div className="row-our-story-squared">
        <div className="col-md-12"> */}
          <hr></hr>
        <br/><i><p className="rebirth-h7"><b>Rebirth of the Heritage House (1974)</b></p></i>
          <p>The modern Heritage House dates to the mid-1970s. In 1974, local businessman Jack Lulofs
            purchased the property and undertook extensive renovations. Jack – a Dutch immigrant and
            experienced masonry contractor – expanded the building with a new addition and made other
            infrastructure improvements.</p>
            <p>The renovated Heritage House adopted a Wisconsin-style supper-club aesthetic, featuring
            vintage decor. “The Heritage House, in its current form, opened roughly half a century ago,” one
            Chicago writer notes, and it still radiates a “trapped-in-amber” 1970s atmosphere with red vinyl
            booths and relish trays reminiscent of mid-century dining.</p>
        <br/><br/><i><p><b>Local Significance</b></p></i>
          <p>Since the 1970s, Heritage House has been a beloved local institution in Harvard and McHenry
County. It served as a gathering place for community events, service club dinners, and family
celebrations. The restaurant even participated in county traditions – for example, in the late 20th
century, Heritage House was a winning bidder for 4-H livestock at the McHenry County Fair’s
auction, underscoring its ties to the rural community.<br/><br/>
As a member of the Chamber of Commerce and a long-standing employer in town, Heritage
House has become an integral part of Harvard’s social fabric. Notably, Jack Lulofs owned
Heritage House from 1974 until his passing in 2011, after which his wife, Lissie, took over its
operation ran the business until her recent passing. Their legacy will live on! During their stewardship, what began as an old highway grill was preserved and
transformed into a nostalgic supper club.<br/><br/>
Today, the Heritage House stands as a living piece of local history. It continues the highway
roadhouse tradition, updated in 1974 but with roots that reach back well before then.</p></div>
      </div><br/><div className="our-story-spacer"></div></div>
  </span>
  );
}

export default Story;
